import { render, staticRenderFns } from "./M2hConsentDialog.vue?vue&type=template&id=34afb42a&scoped=true&"
import script from "./M2hConsentDialog.vue?vue&type=script&lang=js&"
export * from "./M2hConsentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34afb42a",
  null
  
)

export default component.exports